import React, { useState, useRef } from 'react';
import Header from '../../components/Header';
import './index.css';
import api from '../../services/api_irrigacao';
import { FaCloudDownloadAlt } from "react-icons/fa";
import { mask, unMask } from 'remask';
import { parse } from 'date-fns';
import { format } from 'date-fns-tz';
import styles from './styles.module.css';
import fileDownload from 'js-file-download';

export default function EfPorHora() {

    const [downloading, setDownloading] = useState(false);

    const [dataIni, setDataIni] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [frotaIni, setFrotaIni] = useState('');
    const [frotaFim, setFrotaFim] = useState('');
    const [implementoIni, setImplementoIni] = useState('');
    const [implementoFim, setImplementoFim] = useState('');

    const dataIniRef = useRef(null);
    const dataFimRef = useRef(null);
    const frotaIniRef = useRef(null);
    const frotaFimRef = useRef(null);
    const implementoIniRef = useRef(null);
    const implementoFimRef = useRef(null);



    function handleReport() {

        var filtros = '';

        if (dataIni !== null && dataIni !== '') {
            if (filtros === '') {
                filtros = '?dataini=' + format(parse(dataIni, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            } else {
                filtros = filtros + '&dataini=' + format(parse(dataIni, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            }
        }

        if (dataFim !== null && dataFim !== '') {
            if (filtros === '') {
                filtros = '?datafim=' + format(parse(dataFim, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            } else {
                filtros = filtros + '&datafim=' + format(parse(dataFim, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            }
        }

        if (frotaIni !== null && frotaIni !== '') {
            if (filtros === '') {
                filtros = '?frotaini=' + frotaIni;
            } else {
                filtros = filtros + '&frotaini=' + frotaIni;
            }
        }

        if (frotaFim !== null && frotaFim !== '') {
            if (filtros === '') {
                filtros = '?frotafim=' + frotaFim;
            } else {
                filtros = filtros + '&frotafim=' + frotaFim;
            }
        }

        if (implementoIni !== null && implementoIni !== '') {
            if (filtros === '') {
                filtros = '?implementoini=' + implementoIni;
            } else {
                filtros = filtros + '&implementoini=' + implementoIni;
            }
        }

        if (implementoFim !== null && implementoFim !== '') {
            if (filtros === '') {
                filtros = '?implementofim=' + implementoFim;
            } else {
                filtros = filtros + '&implementofim=' + implementoFim;
            }
        }

        if (filtros === '') {
            filtros = '?relatorio=efhora';
        } else {
            filtros = filtros + '&relatorio=efhora';
        }

        if (filtros === '') {
            filtros = '?orientation=portrait';
        } else {
            filtros = filtros + '&orientation=portrait';
        }

        if (!downloading) {
            setDownloading(true);
            api.get(`/relatorio/pdf${filtros}`, { responseType: 'blob' }).then(function (response) {
                if (response.data) {

                    if (response.data.erro) {
                        alert(response.data.erro)
                    } else {
                        fileDownload(response.data, 'RELATÓRIO DE EFICIENCIA.pdf');
                    }

                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
                setDownloading(false);
            });
        }
    }

    function renderSpin() {
        if (downloading) {
            return (
                <div className={styles.divloading}>
                    <div className={styles.loading}></div>
                </div>
            )
        } else {
            return (
                <div className="buttondownload">

                    <span
                        className=" click btn btn-success "
                        onClick={() => handleReport()}
                    >
                        <FaCloudDownloadAlt /> DOWNLOAD
                    </span>

                </div>
            )
        }

    }

    function handledown(e, ref) {
        if (e.key === "Enter") {
            ref.current.focus();
        }
    }

    function handleMaskData(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        return maskedValue;
    }

    return (
        <div className="container-lg">
            <Header title="RELATÓRIO DE EFICIÊNCIA - COMPARATIVO DE HORAS" />

            <div className="content form">
                <div className="column-desc">
                    <label>PERÍODO:</label>
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="dataini"
                        ref={dataIniRef}
                        value={dataIni}
                        className="form-control edit"
                        placeholder="DATA INICIAL"
                        onKeyDown={(e) => handledown(e, dataFimRef)}
                        onChange={(e) => setDataIni(handleMaskData(e.target.value))}
                    />
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="datafim"
                        ref={dataFimRef}
                        value={dataFim}
                        className="form-control edit"
                        placeholder="DATA FINAL"
                        onKeyDown={(e) => handledown(e, frotaIniRef)}
                        onChange={(e) => setDataFim(handleMaskData(e.target.value))}
                    />
                </div>
                <div className="column-desc">
                    <label>FROTA:</label>
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="frotaini"
                        ref={frotaIniRef}
                        value={frotaIni}
                        className="form-control edit"
                        placeholder="FROTA INICIAL"
                        onKeyDown={(e) => handledown(e, frotaFimRef)}
                        onChange={(e) => setFrotaIni(e.target.value)}
                    />
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="frotafim"
                        ref={frotaFimRef}
                        value={frotaFim}
                        className="form-control edit"
                        placeholder="FROTA FINAL"
                        onKeyDown={(e) => handledown(e, implementoIniRef)}
                        onChange={(e) => setFrotaFim(e.target.value)}
                    />
                </div>
                <div className="column-desc">
                    <label>IMPLEMENTO:</label>
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="impini"
                        ref={implementoIniRef}
                        value={implementoIni}
                        className="form-control edit"
                        placeholder="IMPLEMENTO INICIAL"
                        onKeyDown={(e) => handledown(e, implementoFimRef)}
                        onChange={(e) => setImplementoIni(e.target.value)}
                    />
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="impfim"
                        ref={implementoFimRef}
                        value={implementoFim}
                        className="form-control edit"
                        placeholder="IMPLEMENTO FINAL"
                        onChange={(e) => setImplementoFim(e.target.value)}
                    />
                </div>

            </div>
            {renderSpin()}


        </div>
    )
}